// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1176":"d22346d5","5475":"bcc69b89","8548":"2ebd84b9","8668":"d22346d5"}[chunkId] + ".chunk.css";
};